var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOwnYourDataAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 21.4545C23.745 21.4545 25.95 19.2273 25.95 16.4545C25.95 13.6818 25.23 11 21 11C16.86 11 16.05 13.6818 16.05 16.4545C16.05 19.2273 18.255 21.4545 21 21.4545ZM25.5 21.9091H16.5C14.025 21.9091 12 23.9545 12 26.4545C12 28.9545 14.025 31 16.5 31H25.5C27.975 31 30 28.9545 30 26.4545C30 23.9545 27.975 21.9091 25.5 21.9091Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnYourDataAvatar);
export default __webpack_public_path__ + "static/media/own-your-data-avatar.f4d1e59393329c7d7f9f4fb7b5118633.svg";
export { ForwardRef as ReactComponent };